import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  section: {
    width: '100%',
    padding: theme.spacing(1, 0, 2),
  },
  help: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.8rem',
    marginTop: theme.spacing(0.5),
  },
  switchCell: {
    paddingTop: theme.spacing(3),
  },
  table: {
    'marginTop': theme.spacing(2),
    '& th': {
      fontWeight: 600,
      color: 'rgba(0, 0, 0, 0.6)',
      whiteSpace: 'nowrap',
    },
  },
  stageCell: {
    width: '38%',
  },
  subtitle: {
    fontWeight: 600,
    color: 'rgba(0, 0, 0, 0.6)',
    marginTop: theme.spacing(3),
  },
  emptyState: {
    color: 'rgba(0, 0, 0, 0.54)',
    marginTop: theme.spacing(2),
  },
  filterRow: {
    padding: theme.spacing(0, 0, 1),
  },
  inlineProgress: {
    marginLeft: theme.spacing(1),
    verticalAlign: 'middle',
  },
}));
